export default {
      id: "check-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#check",
      toString: function () {
        return this.url;
      }
    }